import React, { useState } from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { statusColors } from "../../enums/TestrunStatusEnum";
import StatusMenuChip from "./StatusMenuChip";

function StatusMenu({ statuses, initialStatus, onStatusChange, anchorEl, onClose, isChipStyle }) {
  const [selectedStatus, setSelectedStatus] = useState(initialStatus);
  const handleStatusSelect = (status) => {
    setSelectedStatus(status);
    onStatusChange(status);
    onClose();
  };
  let hoverStyle={}
  if (isChipStyle) {
    hoverStyle = {
      "&:hover": {
        backgroundColor: "#eff6ff",
      },
    }
  }

  return (
    <Menu
      anchorEl={anchorEl}  // The anchor element that determines the position of the menu
      open={Boolean(anchorEl)}  // Menu opens if anchorEl is not null
      onClose={onClose} 
      PaperProps={{
        style: {
          width: isChipStyle ? "200px" : "150px",
          marginTop: "8px",
        },
      }}
    >
      {statuses.map((status) => (
        <MenuItem
          key={status}
          onClick={() => handleStatusSelect(status)}
          sx={{
            display: "flex",
            alignItems: "center",
            padding:isChipStyle? "9px 17px" : "8px 16px",
            ...hoverStyle 
          }}
        >
          {!isChipStyle ? <>  <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: statusColors[status] || "#6B7280",
              marginRight: "12px",
              display: "inline-block",
            }}
          />
            <Typography>{status}</Typography>
            {status === selectedStatus && <CheckIcon style={{ marginLeft: "auto", fontSize: "18px" }} />}
          </> :
            <StatusMenuChip status={status} />

          }
        </MenuItem>
      ))}
    </Menu>
  );
}

export default StatusMenu;
